var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audio',{ref:"audio",class:_vm.previewClass,attrs:{"autoplay":"","src":_vm.previewData.preview_path,"controls":"controls"}},[_vm._v("您的浏览器不支持 audio 标签。")])
}
var staticRenderFns = []

export { render, staticRenderFns }